// noinspection JSUnusedGlobalSymbols
// File auto-generated on: 2025-06-03T15:14:56.939Z

import {
    GetDocsReadmeAuthApiResponse,
    GetDocsReadmeAuthApiArg,
    PostDocsReadmeWebhookApiResponse,
    PostDocsReadmeWebhookApiArg
} from "~/api/docsAPI.types";

import { baseAPI as api } from "~/api/baseAPI";
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        getDocsReadmeAuth: build.query<
            GetDocsReadmeAuthApiResponse,
            GetDocsReadmeAuthApiArg
        >({
            query: (queryArg) => ({
                url: "/docs/readme-auth",
                params: {
                    "no-redirect": queryArg["no-redirect"],
                    host: queryArg.host,
                    "redirect-url": queryArg["redirect-url"],
                    "generate-anonymous-token": queryArg["generate-anonymous-token"],
                    "generate-jwt-token": queryArg["generate-jwt-token"],
                },
            }),
            extraOptions: {
                security: {
                    api_key_header: [],
                    api_key: [],
                    "jwt-token": [],
                    "jwt-cookie": [],
                    jwt: [],
                },
            },
        }),
        postDocsReadmeWebhook: build.mutation<
            PostDocsReadmeWebhookApiResponse,
            PostDocsReadmeWebhookApiArg
        >({
            query: (queryArg) => ({
                url: "/docs/readme-webhook",
                method: "POST",
                body: queryArg.docsPostReadmeWebhookRequest,
                headers: {"readme-signature": queryArg["readme-signature"]},
            }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as docsAPI };
export const {
    useGetDocsReadmeAuthQuery,
    useLazyGetDocsReadmeAuthQuery,
    usePostDocsReadmeWebhookMutation,
} = injectedRtkApi;
